const { absoluteUrl } = require("../lib/urls")

// The JSON-LD @id has to be byte-identical to the canonical tag, or the two
// disagree about which URL the page is. absoluteUrl applies the same
// trailing-slash rule Seo.js and HrefLangs.js use, and collapses the duplicate
// slash when frontendSlug already carries a leading one.
function schemaPageUrl(languageCode, frontendSlug) {
    const baseUrl = 'https://findmymethod.org';
    const prefix = languageCode === "en" ? "" : `/${languageCode}`

    return absoluteUrl(baseUrl, `${prefix}/${frontendSlug}`)
}

function generateSchema({
    schemaTypes,
    pageTitle,
    seoDescription,
    schemaImage,
    authorName,
    publishDate,
    modifiedDate,
    pageUrl,
    schemaImageAlt,
    pageThumbnail,
    blogFaqsList
}) {
    const schemaMarkup = []
    
    if(schemaTypes) {
        schemaTypes.forEach(type => {
            let schemaItem;

            if(type === "blogPosting") {
                schemaItem = {
                    "@context": "https://schema.org",
                    "@type": "BlogPosting",
                    "headline": pageTitle,
                    "description": seoDescription,
                    "image": schemaImage,
                    "author": {
                        "@type": "Person",
                        "name": authorName
                    },
                    "publisher": {
                        "@type": "Organization",
                        "name": "FindMyMethod.org",
                        "logo": {
                        "@type": "ImageObject",
                        "url": "https://findmymethod.org/fmm-logo.png"
                        }
                    },
                    "datePublished": publishDate,
                    "dateModified": modifiedDate,
                    "mainEntityOfPage": {
                        "@type": "WebPage",
                        "@id": pageUrl
                    }
                };
            } else if (type === "blogFaqSchema" && Array.isArray(blogFaqsList)) {
                const faqsList = blogFaqsList
                    .filter(item => item.question && item.answer)
                    .map(item => ({
                        "@type": "Question",
                        "name": item.question,
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": item.answer,
                        },
                    }));
                if (faqsList.length > 0) {
                    schemaItem = {
                        "@context": "https://schema.org",
                        "@type": "FAQPage",
                        "mainEntity": faqsList,
                    };
                }
            }

            if (schemaItem) {
                schemaMarkup.push(schemaItem);
            }
        })
    }
    if(pageThumbnail) {
        schemaMarkup.push({
            "@context": "https://schema.org",
            "@type": "ImageObject",
            "contentUrl": schemaImage,
            "url": schemaImage,
            "caption": schemaImageAlt,
            "description": schemaImageAlt,
            "license": "https://findmymethod.org/terms-and-conditions",
            "creditText": "FindMyMethod",
            "creator": {
                "@type": "Organization",
                "name": "FindMyMethod"
            }
        })
    }
    return schemaMarkup;
}


module.exports = {
    schemaPageUrl,
    generateSchema
}
